<template>
    <div style="display: inline-block">
        <div class="form-inline">
            <label class="d-block" for="confirmed_by_client">Confirmed By Client</label>
            &nbsp;<input style="display: inline-block" type="checkbox"
                         id="confirmed_by_client"
                         v-model="checked"
                         @change="showModal">
            <span v-if="checked" class="ml-2"  data-toggle="popover" data-html="true" data-placement="bottom"
                  style="cursor: pointer; margin-left: 10px;"
                  title="Client Confirmation Info" :data-content='`<strong>Scheduler name:</strong> ${confirm_client_info.scheduler_name || "" }</br>`+
            `<strong>Contact Name:</strong> ${confirm_client_info.contact_name || ""}</br>` +
            `<strong>Date:</strong> ${confirm_client_info.date ? $options.filters.dateUs(confirm_client_info.date) : "---"}</br>` +
/*
            `<strong>Phone:</strong> ${confirm_client_info.phone  || ""}</br>` +
*/
            `<strong>Via:</strong> ${confirm_client_info.via || ""}</br>` +
            `<a class="btn btn-sm btn-danger" style="float: right; color: white;">Close</a></br>`'>
                <i class="fa fa-user text-info"></i>
            </span>
        </div>
            <modal-default size="large" active-back-drop ref="addModal" @closeModalX="checked=false" show-footer title="Confirmed by client">
                <div class="form-row" style="transform: scale(1); white-space: normal;">
                    <div class="form-group col-md-12">
                        <label>Scheduler Name</label><br>
                        <input class="form-control d-block" v-model="confirm_client_info.scheduler_name">
                    </div>

                    <div class="form-group col-md-12">
                        <label>Contact Name</label><br>
                        <input class="form-control d-block" v-model="confirm_client_info.contact_name">
                    </div>

<!--                    <div class="form-group col-md-12">
                        <label>Phone</label><br>
                        <input
                            type="text"
                            v-mask="'###-###-####'"
                            class="form-control d-block"
                            v-model="confirm_client_info.phone"
                        />
                    </div>-->


                    <div class="form-group col-md-12">
                        <label>Date</label><br>
                        <input type="date" class="form-control d-block" v-model="confirm_client_info.date">

                    </div>
                    <div class="form-group col-md-12">
                        <label>Via</label><br>
                        <select class="form-control" v-model="confirm_client_info.via">
                            <option>Email</option>
                            <option>Phone</option>
                            <option>Other</option>
                        </select>

                    </div>
                </div>
                <template v-slot:actions>
                    <button type="button" class="btn btn-primary text-xs font-weight-bold mt-2"
                            @click="storeConfirmClient"> Confirm Client
                    </button>
                </template>
            </modal-default>
    </div>
</template>
<script>
$(function () {
    $('[data-toggle="popover"]').popover()
})
export default {
    name: "ScheduleConfirmedByClient",
    props: {
        value: Number,
        scheduleId: String,
        info: {
            type: Object,
        }
    },
    data() {
        return {
            checked: false,
            confirm_client_info: {}
        }
    },
    mounted() {
        this.checked = parseInt(this.value) === 1;
        this.$store.commit('schedules/confirmClient', this.checked)
        this.confirm_client_info = this.info;
        if (!this.confirm_client_info.hasOwnProperty(`contact_name`)){
            this.confirm_client_info[`contact_name`] = ''
        }
        if (!this.confirm_client_info.hasOwnProperty(`via`)){
            this.confirm_client_info[`via`] = null
        }

        if (!this.confirm_client_info.hasOwnProperty(`phone`)){
            this.confirm_client_info[`phone`] = null
        }

        if (!this.confirm_client_info.hasOwnProperty(`date`)){
            this.confirm_client_info[`date`] = null
        }

        document.addEventListener('click', function (e) {
            if (e.target && e.target.textContent === 'Close') {
                $('[data-toggle="popover"]').popover('hide');
            }

            const popoverTrigger = document.querySelector('[data-toggle="popover"]');
            const popover = document.querySelector('.popover');

            if (
                popoverTrigger &&
                !popoverTrigger.contains(e.target) &&
                (!popover || !popover.contains(e.target))
            ) {
                $(popoverTrigger).popover('hide');
            }
        });


    },
    methods: {
        validatePhone() {
            const phonePattern = /^\d{3}-\d{3}-\d{4}$/;
            return phonePattern.test(this.confirm_client_info.phone);
        },
        storeConfirmClient() {

            if (!this.confirm_client_info.contact_name){
                showMessage('e', 'Contact name not provided. Please enter a valid name to continue.')
                return;
            }

            if (!this.confirm_client_info.via){
                showMessage('e', 'Via not provided')
                return;
            }

            if (!this.confirm_client_info.date){
                showMessage('e', 'Date not provided')
                return;
            }

          /*  if (!this.validatePhone()){
                showMessage('w', 'Please enter a valid phone number in the format 123-456-7890')
                return;
            }*/

            let app = this;
            axios.post('/schedules/' + this.scheduleId + '/confirm-client', {
                checked: 1,
                info: this.confirm_client_info
            }).then((e) => {
                showMessage('s', 'Confirmation Successful');
                app.confirm_client_info = e.data
                app.checked = true;
                app.$store.commit('schedules/confirmClient', app.checked)
                app.$refs.addModal.hide();
                app.$forceUpdate()

                setTimeout(() => {
                    $('[data-toggle="popover"]').popover('dispose').popover();
                }, 300);

            })

        },
        showModal() {
            if (this.checked) {
                this.$refs.addModal.show();
            } else {
                if (!confirm('Are you sure? If you uncheck, the contact information will be lost.')) {
                    this.checked = true;
                    const checkbox = document.getElementById("confirmed_by_client");
                    checkbox.checked = true;
                    this.$forceUpdate()
                } else {
                    axios.post('/schedules/' + this.scheduleId + '/confirm-client', {checked: 0}).then((e) => {
                    })
                }
            }
            this.$store.commit('schedules/confirmClient', this.checked)

        }
    }
}
</script>
<style scoped>

</style>
